/* Package JSON Import will be here */
import { forEach, orderBy } from 'lodash';
/* Package JSON Import will be here */

/* Project Import will be here */
import { getAppSettingConfig } from 'services/appConfig';
import { getErrorObject, getResObj } from 'utilities/utils';
import Constants from "utilities/appConstants";
import { updateSelectedSortingFilter, updateSelectedSortingFilterTemp } from "../filter/attrFilter";
import { initializeSorting } from "reducers/products";
import { initializeSortingFilter } from "reducers/filter/attrFilter";

/* TODO: Need to complete the push notification then enable for commit */
/* import { initializeFirebase } from "config/firebaseInit"; */

/* Project Import will be here */

export const types = {
	REQUEST_APP_SETTINGS: 'AppSettings/RequestAppSettings',
	ERROR_APP_SETTINGS: 'AppSettings/ErrorAppSettings',
	LOAD_APP_SETTINGS: 'AppSettings/LoadAppSettings',
};

/* handle dispatch instance for session expire and app data clear manually */
export let dispatchInstance = null;

let initialState = {
	isAppSettingsConfigLoaded: false,
	isLoading: false,
	menuList: [],
	applicationCode: '',
	isShowStockQty: false,
	productListTabs: '',
	otpAuthBeforeOrder: false,
	otpAuthAfterLogin: false,
	customAddToHomeScreen: true,
	isLoadProductsAutomaticallyOnReachBottom: false,
	isEnableExpressDelivery: false,
	isShowOsAmount: false,
	isShowColorCode: false,
	isShowChangePassword: false,
	isShowSimilarProducts: false,
	isShowTax: false,
	hideBannerMapping: false,
	isLandingHomePage: false,
	isShowOrderStatus: false,
	isEnableAcceptTermsAndConditions: false,
	isShowDeliveryTimeDisclaimers: false,
	isEnableMinOrderQty: false,
	isShowOrderResource: false,
	isEnableSO: false,
	isShowPaidInvoiceTab: false,
	payUPaymentUrl: '',
	isEnablePaymentDetails: false,
	isEnableAttrFilter: false,
	awsConfig: null,
	isEnableFoc: false,
	complaintUploadImageCount: 5,
	saveToSmartListCount: 5,
	isShowAWBNumber: false,
	isEnableOrderSummaryQty: false,
	orderSummaryFilterLevelCode: Constants.BRAND,
	isEnableBulkOrderUpload: false,
	bulkOrderProductCount: 30,
	isShowDisclaimers: false,
	retailerLedgerMonthCount: 12,
	isEnableBarCodeScanner: false,
	otpAuthForEveryLogin: false,
	placeOrderUom: "",
	salesReturnUom: "",
	isEnablePlaceOrderCase: false,
	isEnablePlaceOrderPiece: true,
	isEnableSalesReturnCase: false,
	isEnableSalesReturnPiece: true,
	isShowSIHColorCode: false,
	isRestrictSIHProducts: false,
	isEnableScrollToTop: false,
	isLoginWithPassword: false,
	firebaseConfig: {
		apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
		projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
		messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
		appId: process.env.REACT_APP_FIREBASE_APP_ID,
		vapidKey: process.env.REACT_APP_VAPID_KEY
	},
	defaultProductSorting: Constants.DEFAULT,
	isShowDeliveryTypeInfoSection: false,
	isShowNarrationInSchemeDetailsPage: false,
	isEnableSmartListGrowthFactor: false,
	isEnableChangeMobileNumber: false,
	isEnableResetPassword: false,
	isHistoryFilterSearchByMonth: false,
	isEnableResendOtp: false,
	isPriceIncludingTax: false,
	isEnableProductNameWordWrap: false,
	orderVolume: "",
	isEnableOrderVolume: false,
	orderVolumeMetric: "",
	orderVolumeConversionCode: "",
	isEnableAttrSorting: true,
	isEnableRewardOtp: false,
	isEnableOrderHistoryExport: false,
	isEnableRepeatOrder: false,
	loyaltyEnableAttrMapping: false,
	loyaltyEnableVendor: false,
	loyaltyVendorFilterSingleSelection: false,
	loyaltyRedemptionApproval: false,
	isEnableOnboardContractAgreement: false,
	isShowTargetVsAchievementDashboard: false,
	cashVoucher: "",
	isEnableCashVoucher: false,
	cashVoucherConversionRate: 1,
	isShowOrderDeliveryDate: false,
	isEnableRewardOrderDeliveryConfirmation: false,
	showDistributorInRewardHistory: false,
	askDistributorSelectionOnEveryLogin: false,
	monthlySalesConfigJson: null,
	historyFilter: null,
	isEnableEditOrder: false,
	isUnDeliveredOrderHighlight: false,
	IsSequenceOrder: true,

	/* product Card Labels config */
	hideProductCardLabels: "",
	isShowConversionQtyLabel: true,
	isEnableMRP: true,
	isEnableSP: true,

	/* Cart page TabContext,Discount,net, disclaimer Labels config */
	showCartLabels: "",
	isShowCartLabelTax: false,
	isShowCartLabelDiscount: false,
	isShowCartLabelNet: false,
	isShowCartLabelDisclaimer: false,
	isShowCartLabelOrderVolume: false,

	/* Page page sections config */
	homePageSections: "",
	homePageSectionsArray: [],

	/* Delivery address configs */
	deliveryAddressActions: "",
	isChangeDeliveryAddress: false,
	isAddDeliveryAddress: false,
	isEditDeliveryAddress: false,
	isDeleteDeliveryAddress: false,

	/* Profile sections configs*/
	retailerProfileSections: "",
	isShowCreditDetailsSection: false,
	isShowMyCompanyRepDetailsSection: false,
	isShowMyDistRepDetailsSection: false,

	/* Hide profile fields configs*/
	hideRetailerProfileFields: "",
	hideProfileFirstName: false,
	hideProfileMiddleName: false,
	hideProfileLastName: false,
	hideProfileEmail: false,
	hideProfileMobile: false,
	hideProfileChannel: false,
	hideProfileSubChannel: false,
	hideProfilePanField: false,
	hideProfileGstField: false,
	hideProfileDeliverySchedule: false,

	/* Order split */
	orderSplit: "",
	isEnableOrderSplit: false,

	/* Support helpline */
	supportHelplineSections: "",
	isEnableHelpMobile: false,
	isEnableHelpEmail: false,
	isEnableHelpExternalLink: false,

	/* Menu configs */
	isEnableHomePage: false,
	isShowSmartListProducts: false,
	isFavProductEnable: false,
	isShowSalesReturn: false,
	isEnableComplaints: false,
	isEnableDigitalContent: false,
	isShowNotifications: false,
	isShowRetailerProfile: false,
	isEnableBToC: false,
	isEnableKpiDashboard: false,
	isEnablePayment: false,
	isEnableOrderStatusDelivery: false,
	isEnableRetailerLedger: false,
	isEnableQpsScheme: false,
	isEnableExchangeReturn: false,
	isEnableCancelOrder: false,
	isEnableSettings: false,
	isEnableSupportHelpline: false,
	isEnableMyRewards: true,
	isEnableManageDistributors: false,
	isEnableSurveyRemainder: false,
	IsEnableLogout: false,
	isEnableVoiceSearch: true,
	mobileFieldRestriction: "10,25",
	minMobileLength: 10,
	maxMobileLength: 25,
	error: null,
	hideProductTax: false,
	hideFssaiNumber: false
};

export const appSettings = (state = initialState, action) => {
	switch (action.type) {
		case types.REQUEST_APP_SETTINGS:
			return { ...state, isLoading: true };
		case types.LOAD_APP_SETTINGS:
			return { ...state, ...action.payload, error: null, isLoading: false };
		case types.ERROR_APP_SETTINGS:
			return { ...state, isLoading: false, error: action.payload.error };
		default:
			return state;
	}
};

/* Clear dispatchInstance during logout */
export const clearDispatchInstance = () => {
	return async (dispatch, getState) => {
		dispatchInstance = null;
	};
};

export const loadAppSettingConfig = (token = null) => {
	return async (dispatch, getState) => {
		/* Assign dispatch object to dispatchInstance */
		dispatchInstance = dispatch;

		/* Make API call when the app setting data not loaded already */
		let isAppSettingsLoadedAlready: Boolean = getState().appSettings.isAppSettingsConfigLoaded;
		if (!isAppSettingsLoadedAlready) {
			dispatch({ type: types.REQUEST_APP_SETTINGS });
			try {
				const response = await getAppSettingConfig(token);

				if (response.data.Status) {
					let responseConfigObject = {
						isAppSettingsConfigLoaded: true,
					};

					const responseObj = getResObj(response.data.Data);
					forEach(responseObj.Configs, (o) => {

						switch (o.key) {
							case 'applicationCode':
								responseConfigObject.applicationCode = o.value;
								break;
							case 'isShowStockQty':
								responseConfigObject.isShowStockQty = o.value === 'true';
								break;
							case 'productListTabs':
								responseConfigObject.productListTabs = o.value;
								break;
							case 'otpAuthBeforeOrder':
								responseConfigObject.otpAuthBeforeOrder = o.value === 'true';
								break;
							case 'otpAuthAfterLogin':
								responseConfigObject.otpAuthAfterLogin = o.value === 'true';
								break;
							case 'isLoadProductsAutomaticallyOnReachBottom':
								responseConfigObject.isLoadProductsAutomaticallyOnReachBottom = o.value === 'true';
								break;
							case 'isEnableExpressDelivery':
								responseConfigObject.isEnableExpressDelivery = o.value === 'true';
								break;
							case 'isShowOsAmount':
								responseConfigObject.isShowOsAmount = o.value === 'true';
								break;
							case 'isShowColorCode':
								responseConfigObject.isShowColorCode = o.value === 'true';
								break;
							case 'isShowChangePassword':
								responseConfigObject.isShowChangePassword = o.value === 'true';
								break;
							case 'isShowSimilarProducts':
								responseConfigObject.isShowSimilarProducts = o.value === 'true';
								break;
							case 'isShowTax':
								responseConfigObject.isShowTax = o.value === 'true';
								break;
							case 'hideProductTax':
								responseConfigObject.hideProductTax = o.value === 'true';
								break;
							case 'hideFssaiNumber':
								responseConfigObject.hideFssaiNumber = o.value === 'true';
								break;
							case 'hideBannerMapping':
								responseConfigObject.hideBannerMapping = o.value === 'true';
								break;
							case 'isLandingHomePage':
								responseConfigObject.isLandingHomePage = o.value === 'true';
								break;
							case 'isShowOrderStatus':
								responseConfigObject.isShowOrderStatus = o.value === 'true';
								break;
							case 'isEnableAcceptTermsAndConditions':
								responseConfigObject.isEnableAcceptTermsAndConditions = o.value === 'true';
								break;
							case 'isShowDeliveryTimeDisclaimers':
								responseConfigObject.isShowDeliveryTimeDisclaimers = o.value === 'true';
								break;
							case 'isEnableMinOrderQty':
								responseConfigObject.isEnableMinOrderQty = o.value === 'true';
								break;
							case 'isShowOrderResource':
								responseConfigObject.isShowOrderResource = o.value === 'true';
								break;
							case 'isEnableSO':
								responseConfigObject.isEnableSO = o.value === 'true';
								break;
							case 'isShowPaidInvoiceTab':
								responseConfigObject.isShowPaidInvoiceTab = o.value === 'true';
								break;
							case 'payUPaymentUrl':
								responseConfigObject.payUPaymentUrl = o.value;
								break;
							case 'isEnablePaymentDetails':
								responseConfigObject.isEnablePaymentDetails = o.value === 'true';
								break;
							case 'isEnableAttrFilter':
								responseConfigObject.isEnableAttrFilter = o.value === 'true';
								break;
							case 'AwsConfig':
								responseConfigObject.awsConfig = JSON.parse(o.value);
								break;
							case 'isEnableFoc':
								responseConfigObject.isEnableFoc = o.value === 'true';
								break;
							case 'complaintUploadImageCount':
								responseConfigObject.complaintUploadImageCount = o.value;
								break;
							case 'saveToSmartListCount':
								responseConfigObject.saveToSmartListCount = o.value;
								break;
							case 'isShowAWBNumber':
								responseConfigObject.isShowAWBNumber = o.value === 'true';
								break;
							case 'isEnableOrderSummaryQty':
								responseConfigObject.isEnableOrderSummaryQty = o.value === 'true';
								break;
							case 'orderSummaryFilterLevelCode':
								responseConfigObject.orderSummaryFilterLevelCode = o.value;
								break;
							case 'isEnableBulkOrderUpload':
								responseConfigObject.isEnableBulkOrderUpload = o.value === 'true';
								break;
							case 'bulkOrderProductCount':
								responseConfigObject.bulkOrderProductCount = o.value;
								break;
							case 'isShowDisclaimers':
								responseConfigObject.isShowDisclaimers = o.value === 'true';
								break;
							case 'retailerLedgerMonthCount':
								responseConfigObject.retailerLedgerMonthCount = o.value;
								break;
							case 'isEnableBarCodeScanner':
								responseConfigObject.isEnableBarCodeScanner = o.value === 'true';
								break;
							case 'otpAuthForEveryLogin':
								responseConfigObject.otpAuthForEveryLogin = o.value === 'true';
								break;
							case 'placeOrderUom':
								responseConfigObject.placeOrderUom = o.value;

								if (o.value !== "") {
									responseConfigObject.isEnablePlaceOrderCase = o.value.includes(Constants.CASE);
									responseConfigObject.isEnablePlaceOrderPiece = o.value.includes(Constants.PIECE);
								}
								else {
									responseConfigObject.isEnablePlaceOrderPiece = true;
								}
								break;
							case 'salesReturnUom':
								responseConfigObject.salesReturnUom = o.value;

								if (o.value !== "") {
									responseConfigObject.isEnableSalesReturnCase = o.value.includes(Constants.CASE);
									responseConfigObject.isEnableSalesReturnPiece = o.value.includes(Constants.PIECE);
								}
								else {
									responseConfigObject.isEnableSalesReturnPiece = true;
								}
								break;
							case 'isShowSIHColorCode':
								responseConfigObject.isShowSIHColorCode = o.value === 'true';
								break;
							case 'isRestrictSIHProducts':
								responseConfigObject.isRestrictSIHProducts = o.value === 'true';
								break;
							case 'isEnableScrollToTop':
								responseConfigObject.isEnableScrollToTop = o.value === 'true';
								break;
							case 'isLoginWithPassword':
								responseConfigObject.isLoginWithPassword = o.value === 'true';
								break;
							case 'firebaseConfig':
								responseConfigObject.firebaseConfig = JSON.parse(o.value);
								break;
							case 'defaultProductSorting':
								responseConfigObject.defaultProductSorting = o.value !== "" ? o.value : Constants.DEFAULT;
								dispatch(initializeSorting(responseConfigObject.defaultProductSorting));
								dispatch(initializeSortingFilter(responseConfigObject.defaultProductSorting));
								break;
							case 'isShowDeliveryTypeInfoSection':
								responseConfigObject.isShowDeliveryTypeInfoSection = o.value === 'true';
								break;
							case 'isShowNarrationInSchemeDetailsPage':
								responseConfigObject.isShowNarrationInSchemeDetailsPage = o.value === 'true';
								break;
							case 'isEnableOnboardContractAgreement':
								responseConfigObject.isEnableOnboardContractAgreement = o.value === 'true';
								break;
							case 'isShowTargetVsAchievementDashboard':
								responseConfigObject.isShowTargetVsAchievementDashboard = o.value === 'true';
								break;
							case 'retailerProfileSections':
								responseConfigObject.retailerProfileSections = o.value;

								if (o.value !== "" && o.value.split(",").length > 0) {
									forEach(o.value.split(","), (profileItems) => {
										if (profileItems === Constants.PROFILE_SECTION_CREDIT_DETAILS)
											responseConfigObject.isShowCreditDetailsSection = true;
										else if (profileItems === Constants.PROFILE_SECTION_MY_COMPANY_REP_DETAILS)
											responseConfigObject.isShowMyCompanyRepDetailsSection = true;
										else if (profileItems === Constants.PROFILE_SECTION_MY_DIST_REP_DETAILS)
											responseConfigObject.isShowMyDistRepDetailsSection = true;
									});
								}
								break;
							case 'supportHelplineSections':
								responseConfigObject.supportHelplineSections = o.value;
								if (o.value !== "" && o.value.split(",").length > 0) {
									forEach(o.value.split(","), (item) => {
										if (item === Constants.SUPPORT_HELPLINE_MOBILE)
											responseConfigObject.isEnableHelpMobile = true;
										else if (item === Constants.SUPPORT_HELPLINE_EMAIL)
											responseConfigObject.isEnableHelpEmail = true;
										else if (item === Constants.SUPPORT_HELPLINE_EXTERNAL_LINK)
											responseConfigObject.isEnableHelpExternalLink = true;
									});
								}
								break;
							case 'hideRetailerProfileFields':
								responseConfigObject.hideRetailerProfileFields = o.value;

								if (o.value !== "" && o.value.split(",").length > 0) {
									forEach(o.value.split(","), (profileField) => {
										if (profileField === Constants.PROFILE_FIELD_FIRST_NAME)
											responseConfigObject.hideProfileFirstName = true;
										else if (profileField === Constants.PROFILE_FIELD_MIDDLE_NAME)
											responseConfigObject.hideProfileLastName = true;
										else if (profileField === Constants.PROFILE_FIELD_LAST_NAME)
											responseConfigObject.hideProfileMiddleName = true;
										else if (profileField === Constants.PROFILE_FIELD_EMAIL)
											responseConfigObject.hideProfileEmail = true;
										else if (profileField === Constants.PROFILE_FIELD_MOBILE)
											responseConfigObject.hideProfileMobile = true;
										else if (profileField === Constants.PROFILE_FIELD_CHANNEL)
											responseConfigObject.hideProfileChannel = true;
										else if (profileField === Constants.PROFILE_FIELD_SUB_CHANNEL)
											responseConfigObject.hideProfileSubChannel = true;
										else if (profileField === Constants.PROFILE_FIELD_PAN)
											responseConfigObject.hideProfilePanField = true;
										else if (profileField === Constants.PROFILE_FIELD_GST)
											responseConfigObject.hideProfileGstField = true;
										else if (profileField === Constants.PROFILE_FIELD_DSchedule)
											responseConfigObject.hideProfileDeliverySchedule = true;
									});
								}
								break;
							case 'deliveryAddressActions':
								responseConfigObject.deliveryAddressActions = o.value;

								if (o.value !== "" && o.value.split(",").length > 0) {
									forEach(o.value.split(","), (addrItems) => {
										if (addrItems === Constants.ADDRESS_ACTION_ADD)
											responseConfigObject.isAddDeliveryAddress = true;
										else if (addrItems === Constants.ADDRESS_ACTION_EDIT)
											responseConfigObject.isEditDeliveryAddress = true;
										else if (addrItems === Constants.ADDRESS_ACTION_DELETE)
											responseConfigObject.isDeleteDeliveryAddress = true;
										else if (addrItems === Constants.ADDRESS_ACTION_CHANGE)
											responseConfigObject.isChangeDeliveryAddress = true;
									});
								}
								break;
							case 'isEnableSmartListGrowthFactor':
								responseConfigObject.isEnableSmartListGrowthFactor = o.value === 'true';
								break;
							case 'isEnableChangeMobileNumber':
								responseConfigObject.isEnableChangeMobileNumber = o.value === 'true';
								break;
							case 'isEnableResetPassword':
								responseConfigObject.isEnableResetPassword = o.value === 'true';
								break;
							case 'isHistoryFilterSearchByMonth':
								responseConfigObject.isHistoryFilterSearchByMonth = o.value === 'true';
								break;
							case 'isEnableResendOtp':
								responseConfigObject.isEnableResendOtp = o.value === 'true';
								break;
							case 'ISPRICE_INCULUDING_TAX':
								responseConfigObject.isPriceIncludingTax = o.value === 'true';
								break;
							case 'isEnableProductNameWordWrap':
								responseConfigObject.isEnableProductNameWordWrap = o.value === 'true';
								break;
							case 'homePageSections':
								responseConfigObject.homePageSections = o.value;
								if (o.value !== "" && o.value.split(",").length > 0)
									responseConfigObject.homePageSectionsArray = o.value.split(",");
								break;
							case 'loyaltyEnableVendor':
								responseConfigObject.loyaltyEnableVendor = o.value === 'true';
								break;
							case 'loyaltyVendorFilterSingleSelection':
								responseConfigObject.loyaltyVendorFilterSingleSelection = o.value === 'true';
								break;
							case 'loyaltyRedemptionApproval':
								responseConfigObject.loyaltyRedemptionApproval = o.value === 'true';
								break;
							case 'cashVoucher':
								responseConfigObject.cashVoucher = o.value;
								if (o.value !== "" && o.value.split(",").length > 0) {
									responseConfigObject.isEnableCashVoucher = o.value.split(",")[0] === 'true';
									responseConfigObject.cashVoucherConversionRate = o.value.split(",")[1];
								}
								break;
							case 'orderVolume':
								responseConfigObject.orderVolume = o.value;
								if (o.value !== "" && o.value.split(",").length > 0) {
									responseConfigObject.isEnableOrderVolume = o.value.split(",")[0] === 'true';
									responseConfigObject.orderVolumeMetric = o.value.split(",")[1];
									responseConfigObject.orderVolumeConversionCode = o.value.split(",")[2];
								}
								break;
							case 'isEnableAttrSorting':
								responseConfigObject.isEnableAttrSorting = o.value === 'true';
								break;
							case 'isEnableRewardOtp':
								responseConfigObject.isEnableRewardOtp = o.value === 'true';
								break;
							case 'isEnableOrderHistoryExport':
								responseConfigObject.isEnableOrderHistoryExport = o.value === 'true';
								break;
							case 'isEnableRepeatOrder':
								responseConfigObject.isEnableRepeatOrder = o.value === 'true';
								break;
							case 'loyaltyEnableAttrMapping':
								responseConfigObject.loyaltyEnableAttrMapping = o.value === 'true';
								break;
							case 'orderSplit':
								responseConfigObject.orderSplit = o.value;
								if (o.value !== "" && o.value.split(",").length > 0)
									responseConfigObject.isEnableOrderSplit = o.value.split(",")[0] === 'true';
								break;
							case 'hideProductCardLabels':
								responseConfigObject.hideProductCardLabels = o.value;
								if (o.value !== "" && o.value.split(",").length > 0) {
									forEach(o.value.split(","), (items) => {
										if (items === Constants.CONVERSION_QTY_LABEL)
											responseConfigObject.isShowConversionQtyLabel = false;
										else if (items === Constants.MRP_LABEL)
											responseConfigObject.isEnableMRP = false;
										else if (items === Constants.SP_LABEL)
											responseConfigObject.isEnableSP = false;
									});
								}
								break;
							case 'showCartLabels':
								responseConfigObject.showCartLabels = o.value;

								if (o.value !== "" && o.value.split(",").length > 0) {
									forEach(o.value.split(","), (items) => {
										if (items === Constants.TAX_LABEL)
											responseConfigObject.isShowCartLabelTax = true;
										else if (items === Constants.DISCOUNT_LABEL)
											responseConfigObject.isShowCartLabelDiscount = true;
										else if (items === Constants.NET_LABEL)
											responseConfigObject.isShowCartLabelNet = true;
										else if (items === Constants.DISCLAIMER_LABEL)
											responseConfigObject.isShowCartLabelDisclaimer = true;
										else if (items === Constants.ORDER_VOLUME_LABEL)
											responseConfigObject.isShowCartLabelOrderVolume = true;
									});
								}
								break;
							case 'isShowOrderDeliveryDate':
								responseConfigObject.isShowOrderDeliveryDate = o.value === 'true';
								break;
							case 'isEnableRewardOrderDeliveryConfirmation':
								responseConfigObject.isEnableRewardOrderDeliveryConfirmation = o.value === 'true';
								break;
							case 'showDistributorInRewardHistory':
								responseConfigObject.showDistributorInRewardHistory = o.value === 'true';
								break;
							case 'askDistributorSelectionOnEveryLogin':
								responseConfigObject.askDistributorSelectionOnEveryLogin = o.value === 'true';
								break;
							case 'monthlySalesConfigJson':
								responseConfigObject.monthlySalesConfigJson = JSON.parse(o.value);
								break;
							case 'historyFilter':
								responseConfigObject.historyFilter = JSON.parse(o.value);
								break;
							case 'IsEnableEditOrder':
								responseConfigObject.isEnableEditOrder = o.value === 'true';
								break;
							case 'isUnDeliveredOrderHighlight':
								responseConfigObject.isUnDeliveredOrderHighlight = o.value === 'true';
								break;
							case 'isEnableSurveyRemainder':
								responseConfigObject.isEnableSurveyRemainder = o.value === 'true';
								break;
							case 'IsEnableLogout':
								responseConfigObject.IsEnableLogout = o.value === 'true';
								break;
							case 'isEnableVoiceSearch':
								responseConfigObject.isEnableVoiceSearch = o.value === 'true';
								break;
							case 'mobileFieldRestriction':
								responseConfigObject.mobileFieldRestriction = o.value;
								if (o.value !== "" && o.value.split(",").length > 0) {
									responseConfigObject.minMobileLength = o.value.split(",")[0];
									responseConfigObject.maxMobileLength = o.value.split(",")[1];
								}
								break;
							case 'IsSequenceOrder':
								responseConfigObject.IsSequenceOrder = o.value === 'true';
								break;
							default:
								break;
						}
					});

					/* Get menu config */
					responseConfigObject.menuList = orderBy(responseObj.Menus, ['Seq'], ['asc']);
					forEach(responseObj.Menus, (o) => {
						switch (o.TCode) {
							case 'HomePage':
								responseConfigObject.isEnableHomePage = true;
								break;
							case 'SmartListProducts':
								responseConfigObject.isShowSmartListProducts = true;
								break;
							case 'FavouriteProducts':
								responseConfigObject.isFavProductEnable = true;
								break;
							case 'SalesReturn':
							case 'SalesReturnHistory':
								responseConfigObject.isShowSalesReturn = true;
								break;
							case 'ExchangeReturn':
								responseConfigObject.isEnableExchangeReturn = true;
								break;
							case 'Complaints':
								responseConfigObject.isEnableComplaints = true;
								break;
							case 'DigitalContent':
								responseConfigObject.isEnableDigitalContent = true;
								break;
							case 'Notifications':
								responseConfigObject.isShowNotifications = true;
								break;
							case 'RetailerProfile':
								responseConfigObject.isShowRetailerProfile = true;
								break;
							case 'StoreDashboard':
								responseConfigObject.isEnableBToC = true;
								break;
							case 'KpiDashboard':
								responseConfigObject.isEnableKpiDashboard = true;
								break;
							case 'IvyPayment':
								responseConfigObject.isEnablePayment = true;
								break;
							case 'OrderStatusDelivery':
								responseConfigObject.isEnableOrderStatusDelivery = true;
								break;
							case 'RetailerLedger':
								responseConfigObject.isEnableRetailerLedger = true;
								break;
							case 'QpsScheme':
								responseConfigObject.isEnableQpsScheme = true;
								break;
							case 'CancelOrder':
								responseConfigObject.isEnableCancelOrder = true;
								break;
							case 'SupportHelpline':
								responseConfigObject.isEnableSupportHelpline = true;
								break;
							case 'PwaSettings':
								responseConfigObject.isEnableSettings = true;
								break;
							case 'MyRewards':
								responseConfigObject.isEnableMyRewards = true;
								break;
							case 'ManageDistributors':
								responseConfigObject.isEnableManageDistributors = true;
								break;
							default:
								break;
						}
					});

					/* Dispatch the updated values */
					dispatch({ type: types.LOAD_APP_SETTINGS, payload: responseConfigObject });

					/* TODO: Need to complete the push notification then enable for commit */
					/* Initializing firebase with config values */
					/* initializeFirebase(responseConfigObject.firebaseConfig !== undefined ? responseConfigObject.firebaseConfig : initialState.firebaseConfig); */

					/* Update default sorting filter in attr filter */
					dispatch(updateSelectedSortingFilterTemp(responseConfigObject.defaultProductSorting !== undefined ? responseConfigObject.defaultProductSorting : initialState.defaultProductSorting));
					dispatch(updateSelectedSortingFilter(responseConfigObject.defaultProductSorting !== undefined ? responseConfigObject.defaultProductSorting : initialState.defaultProductSorting));
				}
			} catch (error) {
				const { message } = getErrorObject(error);
				dispatch({
					type: types.ERROR_APP_SETTINGS,
					payload: { error: message },
				});
			}
		}
	};
};
